'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'alarm-clock';
var width = 512;
var height = 512;
var aliases = [9200];
var unicode = 'f34e';
var svgPathData = ['M80 288a176 176 0 1 0 352 0 176 176 0 1 0 -352 0zM232 160l48 0 0 118.1c31.3 31.3 50.6 50.6 57.9 57.9L304 369.9c-6.1-6.1-27.8-27.8-65-65l-7-7 0-137.9z', 'M394.2 53.7c-15.1-9-31.2-16.5-48.1-22.4 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58-8.8-15.4-19.1-29.9-30.7-43.3 1.5-4.6 2.3-9.6 2.3-14.7 0-26.1-21.2-47.2-47.2-47.2-8.2 0-15.8 2.1-22.5 5.7zM19.7 153.2c-12.3-16.1-19.7-36.2-19.7-58 0-52.6 42.6-95.2 95.2-95.2 28 0 53.2 12.1 70.6 31.3-16.8 5.9-32.9 13.4-48.1 22.4-6.7-3.6-14.4-5.7-22.5-5.7-26.1 0-47.2 21.2-47.2 47.2 0 5.1 .8 10.1 2.3 14.7-11.6 13.3-21.8 27.8-30.7 43.3zM432 288a176 176 0 1 0 -352 0 176 176 0 1 0 352 0zM396.5 462.5C358.1 493.4 309.2 512 256 512s-102.1-18.6-140.5-49.5C82.9 495.1 63.1 514.9 56 521.9L22.1 488c7.1-7.1 26.9-26.9 59.5-59.5-31-38.4-49.5-87.3-49.5-140.5 0-123.7 100.3-224 224-224S480 164.3 480 288c0 53.2-18.6 102.1-49.5 140.5 32.6 32.6 52.4 52.4 59.5 59.5L456 521.9c-7.1-7.1-26.9-26.9-59.5-59.5zM280 184l0 94.1c31.3 31.3 50.6 50.6 57.9 57.9L304 369.9c-6.1-6.1-27.8-27.8-65-65l-7-7 0-137.9 48 0 0 24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;